import React, { useState, useEffect } from 'react';
import './SignInModal.css'; 

const RegisterModal = ({ isActuallyOpen, onClose, onSwitchToSignIn }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isActuallyOpen) {
      const timer = setTimeout(() => setIsVisible(true), 20);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isActuallyOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords don't match!"); // Basic validation
      return;
    }
    console.log('Attempting registration with:', { username, email, password });
    // Example: onClose();
  };

  const handleOverlayClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300); // Match CSS transition
  };

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  const handleCloseButtonClick = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const switchToSignIn = (e) => {
    e.preventDefault();
    setIsVisible(false); // Start fade out of register modal
    setTimeout(() => {
      onClose(); // Tell App.js to close register modal
      onSwitchToSignIn(); // Tell App.js to open sign-in modal
    }, 300); // After register modal fades
  };

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isActuallyOpen) {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isActuallyOpen, onClose]);

  if (!isActuallyOpen) {
    return null;
  }

  return (
    <div
      className={`modal-overlay ${isVisible ? 'open' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className="modal-content" onClick={handleModalContentClick}> {/* Using .modal-content from SignInModal.css */}
        <div className="modal-header">
          <h2>Create Account</h2>
          <button onClick={handleCloseButtonClick} className="modal-close-button" aria-label="Close modal">
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="reg-username">Username</label>
            <input
              type="text"
              id="reg-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="reg-email">Email</label>
            <input
              type="email"
              id="reg-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="reg-password">Password</label>
            <input
              type="password"
              id="reg-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="reg-confirm-password">Confirm Password</label>
            <input
              type="password"
              id="reg-confirm-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-actions" style={{ flexDirection: 'column', gap: '15px' }}> {/* Adjusted layout */}
            <button type="submit" style={{ width: '100%' }}>Register</button>
            <p style={{ fontSize: '0.9rem', color: 'rgba(220, 220, 220, 0.8)'}}>
              Already have an account?{' '}
              <a href="#signin" onClick={switchToSignIn} className="form-link">
                Sign In
              </a>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterModal;